/**
 * Internal Elements Icon and Label Mapping
 * 
 * Provides icon names and human-readable labels for each item type
 * that can appear as an internal element in containers.
 * Icon names correspond to keys in the iconMap from edit/utils/icons/index.js
 */

export const getElementTypeIcon = (type) => {
  const icons = {
    title: 'text',
    text: 'text',
    image: 'image',
    video: 'video',
    button: 'button',
    button_collection: 'collection',
    hero: 'hero',
    component: 'component',
    navbar_section: 'section',
    sidebar_section: 'section',
    image_collection: 'collection',
    file: 'file',
  };
  return icons[type] || 'text';
};

export const getElementTypeLabel = (type) => {
  const labels = {
    title: 'Title',
    text: 'Text',
    image: 'Image',
    video: 'Video',
    button: 'Button',
    button_collection: 'Button Collection',
    hero: 'Hero',
    component: 'Component',
    navbar_section: 'Section',
    sidebar_section: 'Section',
    image_collection: 'Image Collection',
    file: 'File',
  };
  return labels[type] || 'Item';
};

